import * as Types from './types';

export const STACK: Types.ISocketStackEntry[] = [];

export const SEND_SYMBOL = Symbol('send');
